<template>
  <div
    v-show="item.status === 'RUNNING'"
    class="grid"
    :class="item.type === 'PORTFOLIO' ? 'grid-cols-2' : 'grid-cols-3'"
  >
    <div
      content="Resultado acumulado do dia"
      v-tippy="{ arrow: true, theme: 'green' }"
    >
      <p class="label_card">Acumulado</p>
      <div class="flex items-center space-x-2">
        <div
          v-if="item.closed_pnl + item.position_profit != 0"
          :class="
            item.closed_pnl + item.position_profit > 0
              ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
              : 'text-ontick-red-500 rotate-180'
          "
          v-html="$icons.arrow_drop"
        ></div>

        <span
          class="h-3 w-3 rounded-full bg-gray-400"
          v-show="item.closed_pnl + item.position_profit == 0"
        ></span>
        <p
          v-if="item.strategy_symbol === 'ANY'"
          class="text-ontick-steel-500 text-left text-sm font-medium dark:text-gray-200"
        >
          {{ multiSymbolClosedPnl | currency }}
        </p>
        <p
          v-else
          class="text-ontick-steel-500 text-left text-sm font-medium dark:text-gray-200"
        >
          {{ (item.closed_pnl + item.position_profit) | currency }}
        </p>
      </div>
    </div>
    <div
      content="Resultado da operação em aberto"
      v-tippy="{ arrow: true, theme: 'green' }"
      :class="item.type === 'PORTFOLIO' ? 'text-right' : 'text-center'"
    >
      <p class="label_card">Resultado</p>
      <div
        class="flex items-center gap-1"
        :class="item.type === 'PORTFOLIO' ? 'justify-end' : 'justify-center'"
      >
        <template
          v-if="
            item.position_status != 'Zerado' ||
            (item.strategy_symbol === 'ANY' && item.curr_positions)
          "
        >
          <!-- ICON -->
          <template v-if="item.strategy_symbol === 'ANY'">
            <div
              v-if="multiSymbolOpenPnl"
              :class="
                multiSymbolOpenPnl > 0
                  ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
                  : 'text-ontick-red-500 rotate-180'
              "
              v-html="$icons.arrow_drop"
            ></div>
            <div
              class="h-3 w-3 rounded-full bg-gray-400"
              v-if="multiSymbolOpenPnl == 0"
            ></div>

            <!-- WAITING -->
            <ontick-loading-ellipsis-component
              v-if="
                getMarketdata[item.strategy_symbol] === null &&
                item.position_status != 'Zerado'
              "
            />

            <!-- RESULT EXISTS -->
            <p
              v-else
              class="text-ontick-steel-500 whitespace-nowrap text-left text-sm font-semibold dark:text-gray-200"
            >
              {{ multiSymbolOpenPnl | currency }}
            </p>
          </template>

          <template v-else>
            <div
              v-if="item.open_pnl"
              :class="
                item.open_pnl > 0
                  ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
                  : 'text-ontick-red-500 rotate-180'
              "
              v-html="$icons.arrow_drop"
            ></div>
            <div
              class="h-3 w-3 rounded-full bg-gray-400"
              v-if="item.open_pnl == 0"
            ></div>
            <!-- WAITING -->
            <ontick-loading-ellipsis-component
              v-if="
                getMarketdata[item.strategy_symbol] === null &&
                item.position_status != 'Zerado'
              "
            />

            <!-- RESULT EXISTS -->
            <p
              v-else
              class="text-ontick-steel-500 whitespace-nowrap text-left text-sm font-semibold dark:text-gray-200"
            >
              {{ item.open_pnl | currency }}
            </p>
          </template>
        </template>
        <p
          class="text-ontick-steel-500 font-medium dark:text-gray-300"
          v-else-if="item.position_status == 'Zerado'"
        >
          -
        </p>
      </div>
    </div>
    <div
      content="Status da posição"
      v-tippy="{ arrow: true, theme: 'green' }"
      v-if="item.type !== 'PORTFOLIO'"
    >
      <p class="label_card text-right">Posição</p>
      <p
        v-if="item.strategy_symbol === 'ANY'"
        :class="
          multiSymbolPosition == 'Zerado'
            ? 'text-ontick-steel-500 font-medium dark:text-gray-300'
            : 'text-ontick-yellow-900 dark:text-ontick-yellow-600 font-semibold'
        "
        class="text-right text-sm uppercase"
      >
        {{ multiSymbolPosition }}
      </p>
      <p
        v-else
        :class="
          textPosition(item.position_status) == 'Zerado'
            ? 'text-ontick-steel-500 font-medium dark:text-gray-300'
            : 'text-ontick-yellow-900 dark:text-ontick-yellow-600 font-semibold'
        "
        class="text-right text-sm uppercase"
      >
        {{ textPosition(item.position_status) }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ontickLoadingEllipsisComponent from "../../../../../../shared/components/basic/ontick-loading-ellipsis.component.vue";

export default {
  components: { ontickLoadingEllipsisComponent },

  props: {
    item: { type: Object },
  },

  computed: {
    ...mapGetters({ getMarketdata: "marketdata/getMarketdata" }),
    multiSymbolClosedPnl() {
      if (this.item?.curr_positions) {
        return this.item.curr_positions.reduce((acc, curr) => {
          return acc + (curr.position_profit + curr.closed_pnl || 0);
        }, 0);
      }
      return 0;
    },
    multiSymbolOpenPnl() {
      if (this.item?.curr_positions) {
        return this.item.curr_positions.reduce((acc, curr) => {
          return acc + (curr.open_pnl || 0);
        }, 0);
      }
      return 0;
    },
    multiSymbolPosition() {
      if (this.item?.curr_positions) {
        let directions = [];
        let directionTranslate = (direction) => {
          switch (direction) {
            case "Comprado":
            case "BUY":
              return "C";
            case "Vendido":
            case "SELL":
              return "V";
            default:
              return direction;
          }
        };
        this.item.curr_positions.forEach((position) => {
          directions.push(directionTranslate(position.position_status));
        });
        let uniqueDirections = Array(...new Set(directions));
        if (uniqueDirections.length === 1) {
          switch (uniqueDirections[0]) {
            case "C":
              return "Compra";
            case "V":
              return "Venda";
            default:
              return uniqueDirections[0];
          }
        } else if (uniqueDirections > 1) {
          return "C/V";
        }
        return "Zerado";
      }
    },
  },

  methods: {
    textPosition(value) {
      let label;
      if (value == "BUY" || value == "Comprado") {
        label = "Compra";
      } else if (value == "SELL" || value == "Vendido") {
        label = "Venda";
      } else {
        label = "Zerado";
      }
      return label;
    },
  },
};
</script>

<style lang="scss" scoped>
.label_card {
  @apply text-xs text-gray-500 dark:text-gray-400;
}
</style>
